/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-restricted-globals */
import { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import { authenticateUser } from "../../services/AuthService";
import useDocumentTitle from "../../hooks/PageTitle";
import MainLogo from '../../assets/logo-lojas-2.png';
import masonLogo from '../../assets/logo-phoenix.jpeg';
import { styles } from "./styles";
import { IUserAuth } from "../../interfaces/IUserAuth";
export default function Login() {
  useDocumentTitle('Login');
  const navigate = useNavigate();
  const { login } = useAuth();
  const [cim, setCim] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!cim || !password) {
      setError('Por favor, preencha todos os campos.');
      return;
    }

    try {
      const data: any = { cim, password };
      console.log('Dados enviados: ', data);
      const response: any = await authenticateUser(data);

      console.log(response);

      if (response && response.access_token && response.access_token.access_token) {
        const { access_token, user }: any = response.access_token;
        const userAuth: IUserAuth = {
          id: Number(user.id),
          lodge_id: Number(user.lodge_id),
          name: user.name,
          cim: user.cim,
          role: user.role,
          degree: user.degree,
          token: access_token,
        };
        console.log(userAuth);
        login({ user: userAuth });
        const path = user.role === 'ADMIN' ? '/admin' : '/home';
        navigate(path);
      } else {
        setError('Credenciais inválidas ou resposta inválida.');
      }
    } catch (error) {
      console.error('Erro durante o login:', error);
      setError('Erro no servidor. Tente novamente mais tarde.');
    }
  };

  return (
    <div style={styles.container}>
      <div className={`
        col-sm-5 d-flex justify-content-center
      `}>
        <form action="" style={styles.loginForm}>
          <img style={styles.logoHeaderLogin} src={masonLogo} alt="Logo Maçonaria" />
          <h1>Login</h1>
          {error && <p style={{ color: 'red' }}>{error}</p>}
          <div>
            <input type="text" name="email" placeholder="Type your cim" onChange={(e) => setCim(e.target.value)} style={styles.input} />
          </div>
          <div>
            <input type="password" name="" placeholder="Type your password" onChange={(e) => setPassword(e.target.value)} style={styles.input} />
          </div>
          <p style={{ marginTop: "10px" }}>
            Não tem uma conta? <Link to="/register">Faça seu registro aqui</Link>
          </p>
          <button style={styles.button} type="submit" onClick={handleLogin}>Login</button>
        </form>
      </div>
      <div className={`
        col-sm-7 d-flex
      `}>
        <img src={masonLogo} alt="Logo Principal" style={{...styles.logo, width: '85%'}} />
      </div>
    </div>
  );
}